module.exports = __webpack_public_path__ + "img/title.e2cdc209.svg";